import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoschUiOptionBarComponent } from './bosch-ui-option-bar.component';
import { BoschUiOptionBarItemComponent } from './bosch-ui-option-bar-item/bosch-ui-option-bar-item.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BoschUiOptionBarComponent, BoschUiOptionBarItemComponent],
  exports: [BoschUiOptionBarComponent, BoschUiOptionBarItemComponent],
})
export class BoschUiOptionBarModule {}
